import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router'
import { connect } from 'react-redux'
import Logo from '../assets/newblacklogo.png'
import { editUser } from '../actions'
import './navbar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUnlock, faCaretDown, faCaretUp, faUser, faVideo, faMoon, faDoorClosed, faQuestionCircle, faShieldAlt, faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { isMobile } from '../misc/selectors'

const mapStateToProps = (state, ownProps) => {
  const { me } = state

  return {
    me,
    view: ownProps.viewParams.view || '',
    isMobile: isMobile(state),
  }
}

class NavbarComp extends Component {
  constructor() {
    super()

    this.state = {
      lastLive: 0,
    }
    this.setState = this.setState.bind(this)

    window.onclick = () => {
      this.setState({showUserMenu: false})
    }
  }

  render() {
    const { me, view } = this.props
    const navElements = []
    navElements.push(
      <a href="/" className="nav-btn" key="logo">
        <img className="logo" src={Logo} role="presentation" />
      </a>
    )

    if (view != 'report') {
      navElements.push(
        <div className="spacer" key="spacer" />
      )

      if (!me.plan || me.plan === '') {
        navElements.push(
          <Link
            key="pricingLink"
            className={`nav-item upgrade`}
            to={`/upgrade?src_internal=${me.user_name ? 'loggedin-navbar-link' : 'anon-navbar-link'}`}
          >
            Upgrade
          </Link>
        )
      }
      if (me.user_name) {
        navElements.push(
          <Link
            key="userLink"
            className={`nav-item user-link`}
            to=""
            onClick={e => {
              this.setState({showUserMenu: true})
              e.stopPropagation();
            }}
            style={{visibility: this.state.showUserMenu ? 'hidden' : 'visible'}}
          >
            My Account <FontAwesomeIcon icon={faCaretDown} />
          </Link>
        )
      } else {
        navElements.push(
            <Link
              key="userLink"
              className="nav-item signup"
              to="/signup?signup_src=navbar"
            >
              Sign Up
            </Link>
          )
      }
    }

    const showUserMenu = this.state.showUserMenu && view != 'report'

    return (
      <div className="app-nav">
        <nav className="navbar navbar-full">
          {navElements}
        </nav>
        {showUserMenu ?
          <div className="user-menu">
            <div className="user-menu-header">My Account <FontAwesomeIcon icon={faCaretUp} /></div>
            <div className="user-menu-separator border-top">MY SETTINGS</div>
            <Link className="user-menu-item" to='/profile'><span className="icon"><FontAwesomeIcon icon={faUser} /></span> My Profile</Link>
            <Link className="user-menu-item" to='/appearance'><span className="icon"><FontAwesomeIcon icon={faVideo} /></span> Player Appearance</Link>
            <Link className="user-menu-item" to='/settings'><span className="icon"><FontAwesomeIcon icon={faUnlock} /></span> Privacy & Security</Link>
            {me.plan ?
              <Link className="user-menu-item" to='/billing'><span className="icon"><FontAwesomeIcon icon={faDollarSign} /></span> Plan & Billing</Link>
            : ""}
            <div className="user-menu-separator">VIEW PREFERENCES</div>
            <div className="user-menu-item dark-mode" onClick={e => {
              e.stopPropagation();
              this.props.dispatch(editUser({
                dark_mode: !this.props.me.dark_mode
              }))
            }}>
              <span className="icon"><FontAwesomeIcon icon={faMoon} /></span> Dark Mode 
              <div className={`toggle ${this.props.me.dark_mode ? 'selected': ''}`}>
                <div className="toggle-knob"></div>
              </div>
            </div>
            <div className="user-menu-separator">MORE OPTIONS</div>
            {!me.plan ?
              <Link className="user-menu-item" to='/upgrade?src_internal=loggedin-dropdown-menu'><span className="icon"><FontAwesomeIcon icon={faShieldAlt} /></span> Upgrade to Pro</Link>
            : ''}
            <div className="user-menu-item" onClick={e => {
              if (window.Beacon) {
                window.Beacon('open') 
              } else {
                window.location = 'mailto:support@streamable.com'
              }
            }}><span className="icon"><FontAwesomeIcon icon={faQuestionCircle} /></span> Contact Support</div>
            <Link className="user-menu-item border-top" to='#' onClick={e => window.location = '/logout'} style={{marginTop: '5px', padding: '10px'}}><span className="icon"><FontAwesomeIcon icon={faDoorClosed} /></span> Log out</Link>
          </div>
        : ''}
      </div>
    )
  }
}

export default connect(
  mapStateToProps
)(NavbarComp)
